import React from 'react'
import { css } from 'aphrodite'
import { Row, Col, Table } from 'reactstrap'

import EditTableRow from './partials/EditTableRow'

import style from './style'

export const SettingsEditor = props => {
  return [
    <Row key={0}>
      <Col>
        <Row>
          <Col>
            <h4 className={css(style.headers.h4)}>Community</h4>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormEditor
              fields={[
                {
                  label: 'eCPM',
                  group: 'community',
                  name: 'eCPM'
                }
                // {
                //   label: 'Auto Active',
                //   group: 'community',
                //   name: 'auto_active'
                // }
              ]}
              {...props}
            />
          </Col>
        </Row>
      </Col>
    </Row>,
    <Row key={1}>
      <Col>
        <Row>
          <Col>
            <h4 className={css(style.headers.h4)}>Mailer</h4>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormEditor
              fields={[
                {
                  label: 'Name',
                  group: 'email',
                  name: 'name'
                },
                {
                  label: 'Address',
                  group: 'email',
                  name: 'address'
                }
              ]}
              {...props}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  ]
}

export const FormEditor = props => {
  return (
    <Row key={0}>
      <Col>
        <Table
          responsive
          className={css(
            style.table.table,
            style[props.theme.name] ? style[props.theme.name].table.table : null
          )}
        >
          <thead>
            <tr>
              <th
                width={`20%`}
                className={css(
                  style.table.th,
                  style[props.theme.name]
                    ? style[props.theme.name].table.th
                    : null
                )}
              />
              <th
                className={css(
                  style.table.th,
                  style[props.theme.name]
                    ? style[props.theme.name].table.th
                    : null
                )}
              />

              <th
                width={`100px`}
                className={`d-none d-md-table-cell ${css(
                  style.table.th,
                  style[props.theme.name]
                    ? style[props.theme.name].table.th
                    : null
                )}`}
              />
            </tr>
          </thead>
          <tbody>
            {props.fields.map((item, index) => (
              <RenderTableRow
                theme={props.theme}
                key={`${item.name}_${index}`}
                title={item.label}
                content={props.settings[item.group][item.name]}
                onClick={e => props.onTRClick(item.group, item.name, e)}
                editor={props.editor}
                name={item.name}
                editComponent={() => (
                  <EditTableRow
                    title={item.label}
                    onInputChange={e => props.onInputChange(item.group, e)}
                    onFormSubmit={e => props.onFormSubmit(item.group, e)}
                    onCancelClick={e =>
                      props.onTRClick(item.group, item.name, e)
                    }
                    editor={props.editor}
                    content={[
                      {
                        type: 'input',
                        label: item.label,
                        name: item.name,
                        value: props.editor.inputs[item.name]
                      }
                    ]}
                  />
                )}
                editable
              />
            ))}
          </tbody>
        </Table>
      </Col>
    </Row>
  )
}

const RenderTableRow = props => {
  if (
    props.editor.active &&
    props.editor.field === props.name &&
    props.editComponent
  ) {
    return props.editComponent()
  }

  return (
    <tr
      className={css(
        style.table.tr,
        !props.editable ? style.tableRow.nonEditable : null,
        style[props.theme.name] ? style[props.theme.name].table.tr : null
      )}
      onMouseEnter={props.onMouseOver}
      onMouseLeave={props.onMouseOver}
      onClick={props.onClick}
    >
      <td
        className={css(
          style.table.td,
          style[props.theme.name] ? style[props.theme.name].table.td : null
        )}
      >
        <span
          className={css(
            style.tableRow.title,
            style[props.theme.name]
              ? style[props.theme.name].tableRow.title
              : null
          )}
        >
          {props.title}
        </span>
      </td>
      <td
        className={css(
          style.table.td,
          style[props.theme.name] ? style[props.theme.name].table.td : null
        )}
      >
        <span
          className={css(
            style.tableRow.content,
            style[props.theme.name]
              ? style[props.theme.name].tableRow.content
              : null
          )}
        >
          {props.content || ''}
        </span>
      </td>
      <td
        className={`d-none d-md-table-cell ${css(
          style.table.td,
          style[props.theme.name] ? style[props.theme.name].table.td : null
        )}`}
      >
        <div
          className={`d-flex justify-content-center align-items-center ${css(
            style.tableRow.edit,
            props.editable
              ? style[props.theme.name]
                ? (style[props.theme.name].tableRow.nonEditableEdit,
                  style.tableRow.nonEditableEdit)
                : style.tableRow.nonEditableEdit
              : null
          )}`}
        >
          <i
            className={`fa fa-pencil`}
            // style={{ opacity: +!!props.state.isHover }}
          />
          <span
            className={css(
              style.tableRow.editSpan,
              style[props.theme.name]
                ? style[props.theme.name].tableRow.editSpan
                : null
            )}
            // style={{
            //   textDecoration:
            //     !!props.state.isHover && props.editable ? `underline` : `none`
            // }}
          >
            Edit
          </span>
        </div>
      </td>
    </tr>
  )
}

export default SettingsEditor



// WEBPACK FOOTER //
// ./src/components/Settings/partials/SettingsEditor/index.js